import Intents, { enums } from '@ux/intents';

// eslint-disable-next-line max-statements
export default (function () {
  const intents = new Intents();

  intents.create('headerNavigatePrimary', {
    styleProperties: [
      enums.properties.FONT_WEIGHT,
      'logoColor',
      'navButtonHoverColor',
      'dividerColor',
      'shadowColor'
    ]
  });

  intents.create('headerGlobalUtilityButton', {
    styleProperties: [
      enums.properties.FOREGROUND_COLOR,
      enums.properties.BACKGROUND_COLOR,
      enums.properties.BORDER_COLOR
    ],
    interactions: [
      enums.interactions.HOVERED,
      enums.interactions.CHOSEN
    ]
  });

  intents.create('headerGlobalUtilityAvatarButton', {
    styleProperties: [
      enums.properties.FOREGROUND_COLOR,
      enums.properties.BACKGROUND_COLOR,
      enums.properties.BORDER_COLOR
    ],
    interactions: [
      enums.interactions.HOVERED,
      enums.interactions.CHOSEN
    ]
  });

  intents.create('headerMenuItem', {
    styleProperties: [
      enums.properties.FOREGROUND_COLOR,
      enums.properties.BACKGROUND_COLOR
    ],
    interactions: [
      enums.interactions.HOVERED,
      enums.interactions.CHOSEN,
      enums.interactions.FOCUSED
    ]
  });

  intents.create('headerInPageNav', {
    styleProperties: [
      enums.properties.FONT_WEIGHT
    ]
  });

  // Sidbar nav
  intents.headerNavigatePrimary.fontWeight = intents.ux.textAction.fontWeight;
  intents.headerNavigatePrimary.logoColor = intents.ux.box.foregroundColor;
  intents.headerNavigatePrimary.navButtonHoverColor = intents.ux.actionHovered.backgroundColor;
  intents.headerNavigatePrimary.dividerColor = intents.ux.box.borderColor;
  // Shadow intent only for resllers
  intents.headerNavigatePrimary.shadowColor = intents.ux.boxHighContrastOverlay.backgroundColor;

  // Global nav
  intents.headerGlobalUtilityButton.foregroundColor = intents.ux.box.foregroundColor;
  intents.headerGlobalUtilityButton.backgroundColor = intents.ux.action.backgroundColor;

  intents.headerGlobalUtilityButtonHovered.foregroundColor = intents.ux.actionHovered.foregroundColor;
  intents.headerGlobalUtilityButtonHovered.backgroundColor = intents.ux.actionHovered.backgroundColor;
  intents.headerGlobalUtilityButtonHovered.borderColor = intents.ux.actionHovered.borderColor;

  intents.headerGlobalUtilityButtonChosen.foregroundColor = intents.ux.actionChosen.foregroundColor;
  intents.headerGlobalUtilityButtonChosen.backgroundColor = intents.ux.actionChosen.backgroundColor;
  intents.headerGlobalUtilityButtonChosen.borderColor = intents.ux.actionChosen.borderColor;

  // Avatar initials
  intents.headerGlobalUtilityAvatarButton.foregroundColor = intents.ux.action.foregroundColor;
  intents.headerGlobalUtilityAvatarButton.backgroundColor = intents.ux.action.backgroundColor;
  intents.headerGlobalUtilityAvatarButton.borderColor = intents.ux.action.borderColor;

  intents.headerGlobalUtilityAvatarButtonHovered.foregroundColor = intents.ux.actionHovered.foregroundColor;
  intents.headerGlobalUtilityAvatarButtonHovered.backgroundColor = intents.ux.actionHovered.backgroundColor;
  intents.headerGlobalUtilityAvatarButtonHovered.borderColor = intents.ux.actionHovered.borderColor;

  intents.headerGlobalUtilityAvatarButtonChosen.foregroundColor = intents.ux.actionChosen.foregroundColor;
  intents.headerGlobalUtilityAvatarButtonChosen.backgroundColor = intents.ux.actionChosen.backgroundColor;
  intents.headerGlobalUtilityAvatarButtonChosen.borderColor = intents.ux.actionChosen.borderColor;

  // Global nav menu items
  intents.headerMenuItem.foregroundColor = intents.ux.action.foregroundColor;
  intents.headerMenuItem.backgroundColor = intents.ux.action.backgroundColor;

  intents.headerMenuItemHovered.foregroundColor = intents.ux.actionHovered.foregroundColor;
  intents.headerMenuItemHovered.backgroundColor = intents.ux.actionHovered.backgroundColor;

  intents.headerMenuItemChosen.foregroundColor = intents.ux.actionChosen.foregroundColor;
  intents.headerMenuItemChosen.backgroundColor = intents.ux.actionChosen.backgroundColor;

  intents.headerMenuItemFocused.foregroundColor = intents.ux.actionFocused.foregroundColor;
  intents.headerMenuItemFocused.backgroundColor = intents.ux.actionFocused.backgroundColor;

  intents.headerInPageNav.fontWeight = intents.ux.textAction.fontWeight;

  return intents;
}());
